import React, { useRef, useState } from "react";
import { Card, Flex } from "antd";
import "./style.scss";
import HalfDonutPieChart from "../../Reuseable/HalfDonutPieChart/HalfDonutPieChart";

const StatsCard = ({ title = "Elapsed Time", time, footer = true, loading = false }) => {
  const chartRef = useRef();
  const [selected, setSelected] = useState(null);

  const { days = 0, hours = 0, minutes = 0, seconds = 0 } = time || {};

  const fullChart = [
    { name: "Days", value: days },
    { name: "Hours", value: hours },
    { name: "Minutes", value: minutes },
    { name: "Seconds", value: seconds },
  ];

  const colors = ["#3B63FF", "#00C9A7", "#FF9F40", "#FF4C61"];

  // handle legend click
  const handleLegendClick = (index) => {
    if (selected === index) {
      setSelected(null);
      chartRef.current?.highlightSlice(null);
    } else {
      setSelected(index);
      chartRef.current?.highlightSlice(index);
    }
  };

  // 🟢 Chart filtering logic
  const displayedChartData =
    selected !== null
      ? [{ name: fullChart[selected].name, value: fullChart[selected].value }]
      : fullChart;

  return (
    <Card className="statsCardTelecaller" loading={loading} style={{ padding: loading ? '20px' : '0' }}>
      <Card className="allocated_Wrapper">
        <Flex vertical className="allocated_content">
          <div className="graph_box">
            <div className="stats_box">
              <div className="allocated_title">{title}</div>

              <div className="allocated_mainData">
                {selected !== null
                  ? `${fullChart[selected].value} ${fullChart[selected].name}`
                  : `${days}d ${hours}h ${minutes}m ${seconds}s`}
              </div>
            </div>

            <div className="allocated_chart">
              <HalfDonutPieChart
                ref={chartRef}
                data={displayedChartData}
                colors={selected !== null ? [colors[selected]] : colors}
                showValues={true}
                formatValue={(v) => v}
                height={80}
                width={140}
                selectedIndex={selected}
              />
            </div>
          </div>

          {footer && (
            <Flex justify="space-between" className="allocated_legend">
              {fullChart.map((item, index) => (
                <div
                  key={index}
                  className={`legend_item ${selected === index ? "active" : ""}`}
                  onClick={() => handleLegendClick(index)}
                >
                  <span
                    className="dot"
                    style={{ background: colors[index] }}
                  ></span>
                  {item.name}
                </div>
              ))}
            </Flex>
          )}
        </Flex>
      </Card>
    </Card>
  );
};

export default StatsCard;
